import { render, staticRenderFns } from "./MenuNavigation.vue?vue&type=template&id=256d6057&scoped=true"
import script from "./MenuNavigation.vue?vue&type=script&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&lang=js"
import style0 from "./MenuNavigation.vue?vue&type=style&index=0&id=256d6057&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256d6057",
  null
  
)

export default component.exports